import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/pro-solid-svg-icons";
import { EnableFundingToggleSwitch } from "../../../components";

const column = [
  {
    label: "Bank Name",
    className: "column-plan-name",
  },
  {
    label: "Account Number",
    className: "column-plan-id",
  },
  {
    label: "Aba Routing Number",
    className: "column-employee",
  },
  {
    label: "Account Type",
    className: "column-total-funding",
  },
  {
    label: "Status",
    className: "column-source-details",
  },
];

const columnData = [
  {
    label: "Bank of England",
    className: "column-plan-name",
  },
  {
    label: "xxxxx98547",
    className: "column-plan-id",
  },
  {
    label: "999876543",
    className: "column-employee",
  },
  {
    label: "Saving",
    className: "column-total-funding",
  },
  {
    label: "Active",
    className: "column-source-details",
  },
];

const PlanCashAccountDetails = (props) => {
  const {
    planId,
    fundingId,
    planCashToggle,
    setPlanCashToggle,
    forfeitureToggle,
    achToggle,
  } = props;

  return (
    <>
      <div className="w-100 rounded planCashAccountDetailsBox">
        <div className="accountgrid">
          <p className="p-15 fw-600 d-flex planCashAccountHeader">
            Plan Cash Account{" "}
          </p>

          <EnableFundingToggleSwitch
            planId={planId}
            modeOfFunding={"planCashAccountEnabled"}
            toggle={planCashToggle}
            setToggle={setPlanCashToggle}
            planCashToggle={planCashToggle}
            forfeitureToggle={forfeitureToggle}
            achToggle={achToggle}
            id={fundingId}
          />
        </div>

        <div className="payroll-columns">
          <>
            <div className="d-flex">
              {column.map((item, index) => {
                return (
                  <p className="ft-12 planCashAccountTableHeader">
                    {item.label}
                    <FontAwesomeIcon className="sortIcon" icon={faSort} />
                  </p>
                );
              })}
            </div>

            <div className="w-120 rounded planCashAccountDetailsCard">
              <div className="d-flex">
                {columnData.map((item, index) => {
                  return (
                    <p className="ft-12 planCashAccountDetailsCardData">
                      {item.label}
                    </p>
                  );
                })}
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default PlanCashAccountDetails;
